import { IRegFormOutput } from '../builders/section_registraion_attributes_builder';
import { Model } from 'utility-ng-kernel';
import { ITypedModel } from 'core-ts-types';
import { HILForm } from '../../interfaces/scheduler_interfaces';

export interface ISectionRegistrationAttributesFormOutputModel {
  id?: HILForm['id'];
  output?: IRegFormOutput;
}

export type SectionRegistrationAttributesFormOutputModel = ITypedModel<ISectionRegistrationAttributesFormOutputModel>;
angular.module('capability-ng-scheduler').factory(
  'ngSectionRegistrationAttributesFormOutputModel',
  () =>
    new Model<ISectionRegistrationAttributesFormOutputModel>({
      id: undefined,
      output: undefined
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_attributes/models/section_registration_attributes_form_output_model.ts